var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Yesterday"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"label",class:{
        increase: _vm.pvUp,
        reduce: !_vm.pvUp,
        none: _vm.publicationStatus && _vm.publicationStatus.color === 'offline',
      }},[_vm._v(" 昨日浏览 ")]),_c('div',{staticClass:"number"},[_vm._v(" "+_vm._s(_vm.publicationStatus && _vm.publicationStatus.color === 'offline' ? '-' : _vm.pv)+" ")])]),_c('div',{staticClass:"right"},[_c('div',{staticClass:"label",class:{
        increase: _vm.uvUp,
        reduce: !_vm.uvUp,
        none: _vm.publicationStatus && _vm.publicationStatus.color === 'offline',
      }},[_vm._v(" 昨日用户 ")]),_c('div',{staticClass:"number"},[_vm._v(" "+_vm._s(_vm.publicationStatus && _vm.publicationStatus.color === 'offline' ? '-' : _vm.uv)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }